import { Button, type ButtonProps } from './ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';

/**
 * Props for ConfirmationDialog component
 */
export interface ConfirmationDialogProps {
  isOpen: boolean;
  title: string;
  description?: string;
  message?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Button variant for confirm action. Defaults to 'destructive-primary' */
  confirmVariant?: ButtonProps['variant'];
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * ConfirmationDialog component
 * A modal dialog for confirming actions, built on Radix UI Dialog
 */
export function ConfirmationDialog({
  isOpen,
  title,
  description,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'destructive',
  onConfirm,
  onCancel
}: ConfirmationDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent showCloseButton={false} className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className='text-sm text-muted-foreground'>
            {description}
          </DialogDescription>
        </DialogHeader>

        {message && (
          <>
            {message}
          </>
        )}

        <DialogFooter className='pt-3'>
          <Button variant="outline" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
